import React, { useEffect, useRef } from 'react';
import '../assets/Gallery.css';
import footerinsta1 from '../assets/imgs/footer-insta1.webp';
import footerinsta2 from '../assets/imgs/footer-insta2.webp';
import footerinsta3 from '../assets/imgs/footer-insta3.webp';
import footerinsta4 from '../assets/imgs/footer-insta4.webp';

const GallerySection = () => {
  const galleryRef = useRef(null);

  useEffect(() => {
    const items = galleryRef.current.querySelectorAll('.gallery-img');
    items.forEach((item, i) => {
      item.style.animationDelay = `${i * 0.3}s`;
      item.classList.add('animate-in');
    });
  }, []);

  return (
    <div className="gallery-section" ref={galleryRef}>
      <div className="gallery-left">
        <div className="gallery-img"><img src={footerinsta1} loading="lazy" alt="Hiking 1" /></div>
        <div className="gallery-img"><img src={footerinsta2} loading="lazy" alt="Hiking 2" /></div>
        <div className="gallery-img"><img src={footerinsta3} loading="lazy" alt="Map Reading" /></div>
      </div>
      <div className="gallery-right">
        <h1>Keep the <span>Oxygen Supply</span></h1>
        <h3>for the future</h3>
        <p>Lorem ipsum dolor amet consectetur adipiscing</p>
        <button className="read-more">READ MORE</button>
        <div className="social-icons">
          <i className="fa fa-twitter" />
          <i className="fa fa-facebook" />
          <i className="fa fa-instagram" />
        </div>
      </div>
    </div>
  );
};

export default GallerySection;
